<app-cinta-superior></app-cinta-superior>
<div class="container">
  <div class="divDerecha">
    <button tabindex="0" arial-label="Enforcar contenido principal" mat-button (click)="irContenido()" matTooltip="Enforcar contenido principal" autofocus="true" id="irBotonContenido" tabindex="5">
      Ir a contenido principal
    </button>
    <a arial-label="Volver al inicio" matTooltip="Volver al inicio" mat-button tabindex="0" (click)="volver()" (keyup.enter)="volver()" autofocus="true" id="irBotonContenido"><i class="fas fa-home"></i></a>
  </div>
</div>
<div class="spaceLoginHeader">
  <app-navbar></app-navbar>
</div>
<div class="backgroundBorder">
  <div class="container styleColorContainer">
    <div class="login-box ">
      <div class="col-md-10">
        <div>
          <div class="row menuLogin">
            <div class="styleButtonLogin">
              <button tabindex="0" mat-raised-button class="styleButton" (click)="login('candidato')" name="btnSocial" [ngClass]="{activoSena: candidato}" matTooltip="Autenticación con SOFIA PLUS" aria-label="Pulse botón para loguearse con las credenciales de su cuenta del Sena sofia plus">
                <img class='imgLogin' alt="Autenticación con SOFIA PLUS" src="assets/img/login/Logotipo-SofiaPlus-para-boton.png">
              </button>
            </div>
            <div class="styleButtonLogin">
              <button mat-raised-button class="styleButton" id="irLogin" tabindex="0" matTooltip="Autenticación con SENA" (click)="login('admin')" [ngClass]="{activoSena: admin}" aria-label="Pulse botón para loguearse con las credenciales de su cuenta del Sena">
                <img class='imgLogin' src="assets/img/login/Logotipo-sena-para-boton.png" alt="Autenticación con SENA">
              </button>
            </div>
            <!--<div class="styleButtonLogin">
                      <button mat-raised-button class="styleButton" tabindex="-1" matTooltip="Autenticación con GOOGLE funcionalidad del botón no está disponible." aria-label="Pulse botón para loguearse con las credenciales de su cuenta de google"><img
            class='imgLogin' alt="Autenticación con GOOGLE" src="assets/img/login/Google.png"></button>
                  </div>
                  <div class="styleButtonLogin">
                      <button mat-raised-button class="styleButton" tabindex="-1" matTooltip="Autenticación con ICloud funcionalidad del botón no está disponible." aria-label="Pulse botón para loguearse con las credenciales de su cuenta de icloud"><img
            class='imgLogin' alt="Autenticación con ICloud" src="assets/img/login/ICloudImage.png"></button>
                  </div>-->
          </div>
          <div class="loginSena text-center  shadow p-3 mb-5 bg-gray rounded" aria-label="Inicio de sesión">
            <h1 id="irFormulario" tabindex="0"><b>Inicio de sesión</b></h1>
            <form (ngSubmit)="ingresar()" #forma="ngForm">
              <div class="formLogin pt-2 mt-2">
                <div *ngIf="admin">
                  <mat-form-field>
                    <input tabindex="0" aria-label="Ingrese su correo institucional" matInput [(ngModel)]="usuarioCand.numDocUsuPersona" matTooltip="Cuenta de correo institucional " pattern="[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$" [(ngModel)]="adminLogin.corElectronico"
                           [class.is-invalid]="correo.invalid" #correo="ngModel" name="corElectronico" type="mail" placeholder="Cuenta de correo institucional" required>
                    <mat-error> Correo inválido</mat-error>
                  </mat-form-field>
                  <mat-form-field>
                    <input tabindex="0" aria-label="Ingrese su número de identificación" matInput type="text" [(ngModel)]="adminLogin.numDocUsuPersona" matTooltip="Número de documento " name="numDocUsuPersona" type="number" placeholder="Número de documento" required>
                    <mat-error> Campo obligatorio</mat-error>
                  </mat-form-field>
                  <mat-form-field>
                    <input tabindex="0" aria-label="Ingrese su numero de contraseña institucional" matInput type="password" [(ngModel)]="adminLogin.contrasena" name="contrasena" matTooltip="Contraseña institucional " placeholder="Contraseña institucional" required>
                    <mat-error> Campo obligatorio</mat-error>
                  </mat-form-field>
                  <div class="boxButton">
                    <button tabindex="0" class="btn btnOrangeLogin btn-block" name="btnOrgange" type="submit" matTooltip="Iniciar sesión " [disabled]="!forma.valid">Iniciar sesión</button>
                  </div>
                </div>
                <div *ngIf="candidato">
                  <p tabindex="0">Recuerda que para ingresar debes estar registrado en Sofia Plus.</p>
                  <mat-form-field>
                    <select matNativeControl [(ngModel)]="candidatoLogin.tipoDocumento" name="tipo" aria-label="Seleccione su tipo de documento" placeholder="Tipo de documento de identidad" required>
                      <option *ngFor="let ty of documentos" [value]="ty.tipo" [matTooltip]="ty.nombre">
                        {{ty.nombre}}
                      </option>

                    </select>
                    <mat-error> Campo obligatorio</mat-error>
                    <!-- <mat-select tabindex="0" aria-label="Seleccione su tipo de documento" placeholder="Tipo de documento de identidad" [(ngModel)]="candidatoLogin.tipoDocumento" name="tipo" matTooltip="Tipo de documento de identidad" required>
                        <mat-option>Seleccione</mat-option>
                        <mat-option *ngFor="let ty of documentos" [value]="ty.tipo" [matTooltip]="ty.nombre">
                            {{ty.nombre}}
                        </mat-option>
                    </mat-select>
                    <mat-error> Campo obligatorio</mat-error> -->

                  </mat-form-field>
                  <mat-form-field class="example-full-width">
                    <input tabindex="0" aria-label="Ingrese su número de identificación" matInput placeholder="Número de documento" [(ngModel)]="candidatoLogin.numDocUsuPersona" matTooltip="Número de documento " name="numDocUsuPersona" maxlength="16" required>
                    <mat-error> Campo obligatorio</mat-error>
                  </mat-form-field>
                  <mat-form-field class="example-full-width">
                    <input tabindex="0" aria-label="Ingrese su numero de contraseña institucional" matInput placeholder="Contraseña " name="numeross" type="password" matTooltip="Contraseña" [(ngModel)]="contrasenaSofiaPLus" required>
                    <mat-error> Campo obligatorio</mat-error>
                  </mat-form-field>
                  <div class="boxButton">
                    <button tabindex="0" class="btn btnOrangeLogin btn-block" name="btnOrgange" type="submit" matTooltip="Iniciar Sesión" aria-label="Iniciar sesión" [disabled]="!candidatoLogin.numDocUsuPersona || contrasenaSofiaPLus.length < 3 ">Iniciar sesión</button>
                  </div>
                </div>
              </div>
            </form>
            <div class="row">
              <div aria-label="Seleccione para registrarse en sopfia plus" class="col-md-6 text-center buttonLogin" matTooltip="Registrarse en SOFIA PLUS ">
                <a href="http://oferta.senasofiaplus.edu.co/sofia-oferta/registro.html" target="_blank">Regístrate</a>
              </div>
              <div aria-label="Seleccione para la ventana de ayuda" class="col-md-6 text-center buttonLogin" matTooltip="Ventana de ayuda">
                <a [routerLink]="" role="button" (click)="ayuda()" (keydown)="btonContenido($event)" aria-label="Ventana de ayuda">Ayuda</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-cinta-inferior></app-cinta-inferior>
